import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/content.styles'
import FadeInHOC from '../FadeInHOC'

const useStyles = makeStyles(styles)

export default function Content({ primaryText, secondaryText }) {
    const classes = useStyles()
    return (
        <FadeInHOC rootClass={classes.root} >
			<h1 className={classes.h1} dangerouslySetInnerHTML={{__html: primaryText}} />
            <h3 className={classes.h3} dangerouslySetInnerHTML={{__html: secondaryText}} />
        </FadeInHOC>
    )
}
